import Vue from 'vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
import { useAuthStore } from './modules/AuthModule'
import { useUserStore } from './modules/UserModule'
import { useAlertStore } from './modules/AlertModule'
import { useAgendaStore } from './modules/AgendaModule'
import { useApplicationStore } from './modules/ApplicationModule'

Vue.use(PiniaVuePlugin)

const pinia = createPinia()

// instâncias dos stores, usadas fora de componentes e nos componentes (ex.: authModule.isAuth)
const authModule = useAuthStore(pinia)
const userModule = useUserStore(pinia)
const alert = useAlertStore(pinia)
const agenda = useAgendaStore(pinia)
const application = useApplicationStore(pinia)

export {
	authModule,
	userModule,
	alert,
	application,
	agenda,
}

export default pinia
